<template>
    <el-dialog custom-class="xian-yu-dialog-class"  title="闲鱼链接配置" :visible.sync="dialogVisible" @close = "close" width="600px" :close-on-click-modal="false" :show-close="false">   
        <div class="xian-yu-dialog-content">
            <div class="head mb20">
                <span>当前配置产品:</span><span>{{formData.product_name}}</span>
            </div>
            <input ref="qrFileInput" type="file" accept="image/*" style="display:none" @change="handleQrFileChange">
            <div class="xian-yu-links-list">
                <div class="xian-yu-link-item" v-for="(item,index) in xianYuData.tableData" :key="index">
                    <el-input class="input-label" v-model="item.link_name" placeholder="备注名称(必填)" size="small" clearable></el-input>
                    <el-input placeholder="请输入内容" v-model="item.xianyu_link" class="input-value" size="small" clearable>
                        <el-button slot="prepend" icon="el-icon-picture-outline" :disabled="xianYuData.loading" @click="triggerRecognize(index)"></el-button>   
                        <span slot="append"><el-button icon="el-icon-delete" @click="deleteXianYuLink(item,index)"></el-button></span>                
                        
                    </el-input>
                </div>
                <el-button type="text" icon="el-icon-plus" @click="plusLink">添加链接</el-button>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取消</el-button>
            <el-button type="primary" size="small" @click="sureAdd" :disabled="xianYuData.loading">确定</el-button>
        </div>
    </el-dialog>
</template>
<script> 
    export default { 
        name: 'xianYuLink',
        props:{
            dialogVisible:{
                type: Boolean,
                default: false,
            },
            formData:{
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        data(){
            return{
                xianYuData:{
                    loading:false,
                    tableData:[],
                    emptyLink:{
                        link_name:"",
                        xianyu_link:'',
                    }
                },
                qrUploadIndex: null
            }
        },
        methods:{
            getXianyuLinks(){
                let data = {
                    product_code:this.formData.product_code,
                    denomination_value: this.formData.face_value
                }
                this.$api.getXianyuLinks(data).then(res=>{ 
                    if(res.status == 1){
                        this.xianYuData.tableData = res.data
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            // 添加链接按钮
            plusLink(){
                // 使用新对象避免各项数据互相影响
                this.xianYuData.tableData.push({...this.xianYuData.emptyLink})
            },
            close(){
                this.$emit('close')
            },
            sureAdd(){
                let emptyIndex = -1
                for(let i = 0; i < this.xianYuData.tableData.length; i++){
                    let item = this.xianYuData.tableData[i]
                    if(item.link_name == ""){
                        emptyIndex = i                       
                        break;
                    }
                }
                if(emptyIndex != -1){
                    this.$message.warning(`第 ${emptyIndex+1} 项的备注名称不能为空`)
                    return;
                }
                let data = {
                    product_code:this.formData.product_code,
                    denomination_value: this.formData.face_value,
                    items: this.xianYuData.tableData,
                }
                this.xianYuData.loading = true
                this.$api.batchSaveXianyuLinks(data).then(res=>{
                    this.xianYuData.loading = false
                    if(res.status == 1){ 
                        this.close();
                        this.$emit('getData')
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.xianYuData.loading = false
                })
            },
            deleteXianYuLink(item,index){
                if(item.id){
                    this.$confirm('此操作将重数据库删除此数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                       this.deleteXianyuLinkapi(item.id)
                    }).catch((e) => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                }else{
                    this.xianYuData.tableData.splice(index,1)
                }
            },
            //删除闲鱼链接配置接口
            deleteXianyuLinkapi(id){
                let data = {
                    link_id:id
                }
                this.$api.deleteXianyuLink(data).then(res=>{
                    if(res.status == 1){ 
                        this.getXianyuLinks()
                        this.$emit('getData')
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            triggerRecognize(index){
                this.qrUploadIndex = index
                if(this.$refs.qrFileInput){
                    this.$refs.qrFileInput.click()
                }
            },
            handleQrFileChange(e){
                const files = e.target.files
                if(!files || !files.length){
                    return
                }
                const file = files[0]
                const formData = new FormData()
                formData.append('image', file)
                this.xianYuData.loading = true
                this.$api.recognizeQrCode(formData).then(res=>{
                    this.xianYuData.loading = false
                    if(res.status == 1){
                        if(this.qrUploadIndex !== null && this.xianYuData.tableData[this.qrUploadIndex]){
                            this.$set(this.xianYuData.tableData[this.qrUploadIndex],'xianyu_link',res.data && res.data.qr_link ? res.data.qr_link : '')
                        }
                    }else{
                        this.$message.error(res.msg || '识别失败')
                    }
                }).catch(()=>{
                    this.xianYuData.loading = false
                }).finally(()=>{
                    this.qrUploadIndex = null
                    e.target.value = ''
                })
            }
        },
        mounted(){
            this.getXianyuLinks()
        }
  }
</script>
<style scoped lang="scss">
.xian-yu-dialog-class{
    .xian-yu-links-list{
        .xian-yu-link-item{
            display: flex;
            margin-bottom: 8px;
            gap:8px;
            .input-label{
                width: 140px;
            }
            .input-value{
                flex: 1;
            }
        }
    }
    
}
</style>